export function dailySessionReset() {
  const today = new Date().toISOString().split('T')[0]; // e.g. "2025-10-08"
  const lastCleanup = localStorage.getItem('lastCleanupDate');

  if (lastCleanup !== today) {
    // Clear storages
    localStorage.clear();
    sessionStorage.clear();

    // Mark cleanup as done
    localStorage.setItem('lastCleanupDate', today);

    // Force full reload to ensure fresh assets (bypass cache).
    // Preserve the current path so anonymous deep links (e.g. /gegevensdelen/:token)
    // are not redirected to the root login flow on first visit / incognito.
    const url = new URL(window.location.href);
    url.searchParams.set('t', Date.now().toString());
    window.location.href = url.toString();
  }
}
